export default __webpack_public_path__ + "static/media/discord.0a117df0.svg";